import {
  MegaphonePromptBanner,
  PROMPT_BANNER_MAX_WIDTH,
  promptBannerV2NeedButtonStyle,
  usePromptBannerCappedContentWidth,
} from 'app/components/prompt-banner-card';
import { Column, Row } from 'app/design/primitives/box';
import type { ViewProps } from 'react-native';
import { View } from 'react-native';
import { Text } from 'app/design/primitives/text';
import { Button } from 'app/design/primitives/button';
import { useNavigation } from 'app/hooks/navigation';
import { ListingType } from 'app/types/listing';

import type { NewListingSource } from 'app/types/listing';
import { Trans, useTranslation } from 'react-i18next';
import { useOpenNewWithGuard } from 'app/hooks/use-open-new';
import { useUISize } from 'app/utils/web-helpers';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconPlus } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

export function PostNeedPromptCard({
  title,
  text,
  buttonText,
  itemName,
  newListingSource,
  v2,
  hideStats,
  ...rest
}: ViewProps & {
  title: string;
  text: string;
  buttonText: string;
  itemName?: string | null;
  newListingSource: NewListingSource;
  v2?: boolean;
  hideStats?: boolean;
}) {
  const { t } = useTranslation('all-listings');
  const navigation = useNavigation();
  const openNewWithGuard = useOpenNewWithGuard();
  const { isSmallUI } = useUISize();
  const v2ButtonWidth = usePromptBannerCappedContentWidth();

  const addNewNeed = () => {
    openNewWithGuard(navigation, {
      defaultValues: {
        type: ListingType.request,
        ...(itemName ? { item: { name: itemName } } : {}),
      },
      newListingSource: newListingSource,
    });
  };

  if (v2) {
    return (
      <View {...rest}>
        <Column
          alignItems="flex-start"
          alignSelf={isSmallUI ? 'stretch' : 'flex-start'}
          gap="spacing.general.x8"
          maxWidth={isSmallUI ? undefined : PROMPT_BANNER_MAX_WIDTH}
          width="100%"
        >
          <Button
            onPress={addNewNeed}
            style={[
              promptBannerV2NeedButtonStyle(v2ButtonWidth, ListingType.request),
              isSmallUI ? { width: '100%' } : null,
            ]}
          >
            <Row alignItems="center" justifyContent="space-between" width="100%">
              <Row alignItems="center" gap="spacing.general.x4">
                <Text fontSize={23} fontWeight="700">
                  👋
                </Text>
                <Text color="text.primary" fontWeight="700" variant="bodyLarge">
                  {t(buttonText)}
                </Text>
              </Row>
              <IconPlus strokeWidth={ICON_STROKE_WIDTH} size={30} color={theme.colors['text.primary']} />
            </Row>
          </Button>

          {!hideStats ? (
            <Row alignItems="center" gap="spacing.general.x4">
              <Text fontSize={39} fontWeight="700">
                {t(title)}
              </Text>
              <Text flex={1} variant="bodyLarge">
                <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey={text} ns="all-listings" />
              </Text>
            </Row>
          ) : null}
        </Column>
      </View>
    );
  }

  return (
    <View {...rest}>
      <MegaphonePromptBanner
        backgroundColor={theme.colors['surface.tertiary']}
        body={text}
        buttonLabel={buttonText}
        foregroundColor={theme.colors['text.primary']}
        onPress={addNewNeed}
        plusIconColor={theme.colors['surface.tertiary']}
        title={title}
      />
    </View>
  );
}
